export default "__VITE_ASSET__VR1s2Mer__"